import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LeftMenuComponent } from './left-menu/left-menu.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-layout',
    imports: [
        CommonModule,
        RouterOutlet,
        LeftMenuComponent,
        BreadcrumbComponent,
    ],
    templateUrl: './layout.component.html',
    styleUrl: './layout.component.css'
})
export class LayoutComponent {
  toggleSidebar(event: MouseEvent) {
    event.stopPropagation();
    const sidebar = document.getElementById('sidebar');
    if (!sidebar) return;

    // Toggle active class for CSS transitions
    sidebar.classList.toggle('active');

    // Toggle drawer via KeenThemes KTDrawer instance
    const KTDrawer = (window as any)?.KTDrawer;
    if (KTDrawer) {
      const drawer = KTDrawer.getInstance(sidebar);
      if (drawer) {
        drawer.toggle();
      }
    }
  }
}
